import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';

const PlacementTestIntro = () => {
  const navigate = useNavigate();

  return (
    <div className="ob-sky-voyager font-body text-hp-on-surface min-h-screen flex flex-col items-center justify-center p-4 relative overflow-x-hidden">
      <div className="fixed inset-0 ob-cloud-pattern pointer-events-none" />
      <div className="fixed inset-0 ob-star-pattern opacity-30 pointer-events-none" />

      <main className="w-full max-w-[640px] my-12 z-10">
        {/* Progress */}
        <div className="mb-8">
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-semibold text-gray-600">Bước 2/2</span>
            <span className="text-sm font-semibold text-green-600">100%</span>
          </div>
          <div className="w-full h-3 bg-hp-surface-container rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-hupath-scout to-hupath-leaf rounded-full" style={{ width: '100%' }} />
          </div>
        </div>

        {/* Card */}
        <div className="bg-white rounded-2xl shadow-[0px_12px_32px_rgba(94,46,26,0.08)] p-8 md:p-12">

          {/* Header */}
          <div className="flex items-start gap-4 mb-8">
            <span className="text-4xl">🦉</span>
            <div>
              <h1 className="font-headline text-3xl md:text-4xl font-extrabold text-hp-on-surface mb-2">
                Bài đánh giá đầu vào
              </h1>
              <p className="text-hp-on-surface-variant">Hãy để HuPath hiểu con hơn nhé!</p>
            </div>
          </div>

          {/* Features */}
          <div className="grid md:grid-cols-3 gap-6 mb-8 pb-8 border-b-2 border-gray-100">
            <div className="flex gap-3">
              <span className="material-symbols-outlined text-green-600">description</span>
              <div>
                <h3 className="font-bold text-hp-on-surface mb-1">10 câu hỏi</h3>
                <p className="text-sm text-hp-on-surface-variant">Nhiều dạng bài khác nhau</p>
              </div>
            </div>
            <div className="flex gap-3">
              <span className="material-symbols-outlined text-green-600">schedule</span>
              <div>
                <h3 className="font-bold text-hp-on-surface mb-1">Không giới hạn</h3>
                <p className="text-sm text-hp-on-surface-variant">Làm bài thoải mái, không vội</p>
              </div>
            </div>
            <div className="flex gap-3">
              <span className="material-symbols-outlined text-green-600">track_changes</span>
              <div>
                <h3 className="font-bold text-hp-on-surface mb-1">Cá nhân hóa</h3>
                <p className="text-sm text-hp-on-surface-variant">Lộ trình học riêng cho con</p>
              </div>
            </div>
          </div>

          {/* Note */}
          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 mb-8 rounded">
            <div className="flex gap-3">
              <span className="text-2xl">💬</span>
              <p className="text-gray-700">
                Đây không phải bài kiểm tra! Không có đúng hay sai.
                Chúng mình chỉ muốn biết con đang ở đâu để giúp con tốt hơn thôi.
              </p>
            </div>
          </div>

          {/* CTA */}
          <button
            onClick={() => navigate('/placement-test')}
            className="w-full hp-button-gradient text-white font-headline font-bold text-xl py-4 rounded-lg shadow-xl shadow-hupath-scout/20 hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 flex items-center justify-center gap-2 mb-4"
          >
            Bắt đầu đánh giá
            <span className="material-symbols-outlined">arrow_forward</span>
          </button>

          <div className="flex gap-2 items-center text-sm text-hp-on-surface-variant">
            <span className="material-symbols-outlined text-gray-400">info</span>
            <span>Thời gian ước tính: khoảng 5-8 phút</span>
          </div>
        </div>
      </main>

      <div className="fixed bottom-[-100px] left-1/2 -translate-x-1/2 w-[120%] h-[300px] bg-white rounded-[50%] blur-3xl opacity-60 z-0" />
    </div>
  );
};

export default PlacementTestIntro;
